import React from 'react'

import synkdLogo from '../assets/synkd_logo.png';
import clubleaLogo from '../assets/clublea_logo.png';
import { isClubLeaDomain } from '../util'


function Error(props) {
    const logo = isClubLeaDomain() ? clubleaLogo : synkdLogo;
    return (
        <div className='main-container'>
            <img src={logo} style={{marginBottom: '1em'}} width='100px' className="App-logo" alt="logo" />
            <div className='content-container animate__animated animate__fadeIn'>
                <h3 style={{marginTop: '10px'}}>There was a problem</h3>
                {props.children}
            </div>
        </div>
    );
}

export default Error